<ng-template #tpl>
  <ng-content></ng-content>
</ng-template>
